import { ActionCls, LocationCls } from 'constants/constants';
import React, { MouseEvent, PropsWithChildren, RefObject, useRef } from 'react';
import { createPortal } from 'react-dom';
import styles from './ModalScreen.module.scss';
type ModalScreenOwnProps = {
  className?: string;
  hideBgOverlay?: boolean;
  onOverlayClick?: () => void;
};

type ModalScreenProps = PropsWithChildren<ModalScreenOwnProps>;
const ModalScreen: React.FC<ModalScreenProps> = ({
  className = '',
  onOverlayClick = () => undefined,
  hideBgOverlay = false,
  ...props
}) => {
  const overlayRef = useRef<HTMLDivElement>(null);
  const baseCls = `${styles.ModalScreenContainer} ${className}`;
  const hideOverlayCls = hideBgOverlay ? '' : styles.ModalScreenShowBgOverlay;


  const isRefContainsTarget = (target: HTMLDivElement, ref?: RefObject<HTMLDivElement | null>) => {
    if (!ref || ref.current === null) return;

    return target.contains(ref.current);
  };

  const onOverlayClickHandler = (event: MouseEvent<HTMLDivElement>) => {
    if (isRefContainsTarget(event.target as HTMLDivElement, overlayRef)) {
      console.log('%c ModalScreen %c clicked on overlay %c CLOSE %c', LocationCls, '', ActionCls, '');
      onOverlayClick();
    }
  };

  return (
    <>
      {createPortal(
        <div ref={overlayRef} className={`${baseCls} ${hideOverlayCls}`} onClick={onOverlayClickHandler}>
          {props.children}
        </div>,
        document.body
      )}
    </>
  );
};

export default ModalScreen;
